export const NET_CORE_EVENT_PARAM_LIST = {
  appointment_caldata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "term",
    "citerm",
    "adbterm",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "annualincome",
    "page_name",
    "occupation",
    "premium",
    "whatsapp_optin",
    "step",
    "education",
    "city",
    "pincode",
    "state",
    "nri",
    "nrifullname",
    "fullname",
    "nrimoblieno",
    "nriemail",
    "livinginindia",
    "ppt",
    "pagename",
    "uid",
    "sumassured2",
    "timestamp",
    "persona",
    "existing_cust",
    "schedulecalltimestamp",
    "fname",
    "lname",
    "isnri",
    "lms_nri",
    "income_date",
    "p_gender",
    "p_dob",
    "getincome",
    "trai",
    "modalpremium",
    "paymentoption",
    "payoutterm",
    "relation",
    "policyterm",
    "incomemode",
    "mode",
    "income_frequency",
    "rideroptionadded",
    "pensionfrequency",
    "lifecover",
    "payout",
    "productid",
    "invest_type",
    "invest_strat",
    "iswop",
    "wop_selctedoption",
    "rider1",
    "rider2",
    "rider3",
    "propdob",
    "propgender",
    "p_age",
    "cdob",
    "cage",
    "name",
    "crelation",
    "cgender",
    "appointeegender",
    "appointeerelation",
    "iswhatsappopted",
    "propage",
    "payfor",
    "paymentfreq",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "ishousewife",
    "countryname",
    "countrycode",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
  ],
  ipsPlus_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "abterm",
    "adterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "critical_illness_benefit_1",
    "critical_illness_benefit_2",
    "premium_break",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "occupation",
    "education",
    "mrt_sts",
    "appno",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "maritalstatus",
    "city",
    "existing_cust",
    "nri",
    "nrimobileno",
    "timestamp",
    "livinginindia",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "nrflag_1",
    "nrflag_2",
    "nroflag_1",
    "nroflag_2",
    "wantgstflag",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age_1",
    "smart_exit_age_2",
    "smart_exit_age_3",
    "ci_cover_gst",
    "adb_cover_gst",
    "ci_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "gst_waiver",
    "premium_without_gst",
    "total_gst",
    "Smart_Exit_Entry",
    "Smart_Exit_Out",
    "Cover_Till_Age",
    "active_rider",
    "annual_income",
    "PREFERRED_LANGUAGE",
  ],
  ipsplus10year_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "abterm",
    "adterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "critical_illness_benefit_1",
    "critical_illness_benefit_2",
    "premium_break",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "occupation",
    "education",
    "mrt_sts",
    "appno",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "maritalstatus",
    "city",
    "existing_cust",
    "nri",
    "nrimobileno",
    "timestamp",
    "livinginindia",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "nrflag_1",
    "nrflag_2",
    "nroflag_1",
    "nroflag_2",
    "wantgstflag",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age_1",
    "smart_exit_age_2",
    "smart_exit_age_3",
    "ci_cover_gst",
    "adb_cover_gst",
    "ci_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "gst_waiver",
    "premium_without_gst",
    "total_gst",
    "Smart_Exit_Entry",
    "Smart_Exit_Out",
    "Cover_Till_Age",
    "active_rider",
    "annual_income",
    "PREFERRED_LANGUAGE",
  ],
  ipsPlus_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "adbterm",
    "adterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "critical_illness_benefit_1",
    "critical_illness_benefit_2",
    "premium_break",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "occupation",
    "education",
    "mrt_sts",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "city",
    "existing_cust",
    "nri",
    "nrimoblieno",
    "timestamp",
    "livinginindia",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "nreflag_1",
    "nroflag_1",
    "wantgstflag",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age_1",
    "smart_exit_age_2",
    "smart_exit_age_3",
    "ci_cover_gst",
    "adb_cover_gst",
    "ci_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "gst_waiver",
    "premium_without_gst",
    "total_gst",
    "Smart_Exit_Entry",
    "Smart_Exit_Out",
    "Cover_Till_Age",
    "active_rider",
    "PREFERRED_LANGUAGE",
  ],
  ipsplus10year_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "adbterm",
    "adterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "critical_illness_benefit_1",
    "critical_illness_benefit_2",
    "premium_break",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "occupation",
    "education",
    "mrt_sts",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "city",
    "existing_cust",
    "nri",
    "nrimoblieno",
    "timestamp",
    "livinginindia",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "nreflag_1",
    "nroflag_1",
    "wantgstflag",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age_1",
    "smart_exit_age_2",
    "smart_exit_age_3",
    "ci_cover_gst",
    "adb_cover_gst",
    "ci_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "gst_waiver",
    "premium_without_gst",
    "total_gst",
    "Smart_Exit_Entry",
    "Smart_Exit_Out",
    "Cover_Till_Age",
    "active_rider",
    "PREFERRED_LANGUAGE",
  ],
  icare_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "abterm",
    "adterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "critical_illness_benefit_1",
    "critical_illness_benefit_2",
    "premium_break",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "occupation",
    "education",
    "mrt_sts",
    "appno",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "maritalstatus",
    "city",
    "existing_cust",
    "nri",
    "nrimobileno",
    "timestamp",
    "livinginindia",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "nrflag_1",
    "nrflag_2",
    "nroflag_1",
    "nroflag_2",
    "wantgstflag",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age_1",
    "smart_exit_age_2",
    "smart_exit_age_3",
    "ci_cover_gst",
    "adb_cover_gst",
    "ci_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "gst_waiver",
    "premium_without_gst",
    "total_gst",
    "Smart_Exit_Entry",
    "Smart_Exit_Out",
    "Cover_Till_Age",
    "active_rider",
  ],
  icare_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "adbterm",
    "adterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "critical_illness_benefit_1",
    "critical_illness_benefit_2",
    "premium_break",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "occupation",
    "education",
    "mrt_sts",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "city",
    "existing_cust",
    "nri",
    "nrimoblieno",
    "timestamp",
    "livinginindia",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "nreflag_1",
    "nroflag_1",
    "wantgstflag",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age_1",
    "smart_exit_age_2",
    "smart_exit_age_3",
    "ci_cover_gst",
    "adb_cover_gst",
    "ci_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "gst_waiver",
    "premium_without_gst",
    "total_gst",
    "Smart_Exit_Entry",
    "Smart_Exit_Out",
    "Cover_Till_Age",
    "active_rider",
  ],
  ips_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "adbterm",
    "premiumpaymentoption",
    "sumassured",
    "accidental_death_benefit",
    "critical_illness_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "annual_income",
    "occupation",
    "education",
    "mrt_sts",
    "residential_sts",
    "appno",
    "step",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "language",
    "persona",
    "whatsapp_optin",
    "premiumwithci",
    "trai_flag_sm",
    "fname",
    "lname",
    "martialstatus",
    "plan_for",
    "relations",
    "productid",
    "city",
    "salaried",
    "productname",
    "existing_cust",
    "state",
    "nri",
    "ind_flag_nri",
    "internationalmobileno",
    "travelinlast1year",
    "lms_gender",
    "nrifullname",
    "nrimoblieno",
    "nriemail",
    "timestamp",
    "livinginindia",
    "nriarrivingdate",
    "fullname",
    "exitpopup",
    "latname",
    "diabetes",
    "partnerdetails",
    "flag_partner",
    "countrycode",
    "countryname",
    "ishousewife",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "nriindianpincodecity",
    "married",
    "spousedetails",
    "currentpagestep",
    "nreflag",
    "nroflag",
    "wantgstflag",
    "PFP_PK_ID",
    "PRI_MEDICAL_DATE",
  ],
  ips_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "term",
    "citerm",
    "adbterm",
    "premiumpaymentoption",
    "sumassured",
    "accidental_death_benefit",
    "critical_illness_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "annualincome",
    "step",
    "premium",
    "page_name",
    "trai_flag",
    "lead_type",
    "ppt",
    "pagename",
    "uid",
    "sumassured2",
    "appno",
    "firstname",
    "lastname",
    "pincode",
    "language",
    "maritalstatus",
    "pensionfor",
    "purchasefor",
    "spouse_dob",
    "spouse_age",
    "spouse_name",
    "policyterm",
    "nps_flag",
    "keyword",
    "productid",
    "incomebenefit",
    "persona",
    "max_term",
    "nominee",
    "annual_income",
    "occupation",
    "whatsapp_optin",
    "premiumwithci",
    "occ",
    "trai_flag_sm",
    "fname",
    "lname",
    "plan_for",
    "relations",
    "education",
    "city",
    "salaried",
    "productname",
    "existing_cust",
    "state",
    "appdropoff",
    "nri",
    "ind_flag_nri",
    "internationalmobileno",
    "travelinlast1year",
    "nrifullname",
    "nrimoblieno",
    "nriemail",
    "timestamp",
    "livinginindia",
    "nriarrivingdate",
    "fullname",
    "exitpopup",
    "diabetes",
    "partnerdetails",
    "flag_partner",
    "countryname",
    "countrycode",
    "ishousewife",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "mode",
    "qdata",
    "married",
    "spousedetails",
    "currentpagestep",
    "nreflag",
    "nroflag",
  ],
  ips_calcdata_lang_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "citerm",
    "adbterm",
    "premiumpaymentoption",
    "sumassured",
    "accidental_death_benefit",
    "critical_illness_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "annualincome",
    "step",
    "premium",
    "page_name",
    "trai_flag",
    "lead_type",
    "language",
    "ppt",
    "pagename",
    "uid",
    "sumassured2",
    "appno",
    "firstname",
    "lastname",
    "pincode",
    "persona",
    "nominee",
    "annual_income",
    "occupation",
    "next_year_premium",
    "next_year_monthly_premium",
    "next_year_yearly_premium",
    "whatsapp_optin",
    "premiumwithci",
    "trai_flag_sm",
    "fname",
    "lname",
    "relations",
    "productid",
    "education",
    "city",
    "salaried",
    "productname",
    "existing_cust",
    "address",
    "leadflag",
    "appdropoff",
    "state",
    "nri",
    "nrifullname",
    "fullname",
    "nrimoblieno",
    "nriemail",
    "livinginindia",
    "nriarrivingdate",
    "timestamp",
    "travelinlast1year",
    "diabetes",
    "partnerdetails",
    "countryname",
    "countrycode",
    "ishousewife",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "nriindianpincodecity",
    "married",
    "spousedetails",
    "nreflag",
    "nroflag",
  ],
  signature_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "address",
    "pincode",
    "premium",
    "occupation",
    // "nominee",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "uid",
    "annualincome",
    "step",
    "adbr",
    "payout",
    "existing_cust",
    "invest_strat",
    // "fundcat",
    "page_title",
    "modalpremium",
    "staff",
    "name",
    "selectoption_dropdown",
    "investvalue",
    "traiflag",
    "appformdetails",
    "communication",
    "health",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "sourceurl",
    "existingcustomer",
    "qdata_pasa",
    "stay_details",
    "proposer_stay_details",
    "p_gender",
    "p_dob",
    "p_age",
    "rideroptionadded",
    // "rider1",
    // "rider2",
    "education",
    "iswhatsappopted",
    "isnri",
    "lms_nri",
    "health_la",
    "health_pa",
    "iswop",
    // "wop_selctedoption",
    // "rider3",
    "propage",
    "propdob",
    "propgender",
    "city",
    "p_ender",
    "suitcheckbox",
    "qdata",
    "deathbenefitoption",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "maritalstatus",
  ],
  signature_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "address",
    "pincode",
    "premium",
    "occupation",
    // "nominee",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "pagename",
    "uid",
    "appno",
    "annualincome",
    "step",
    "adbr",
    "payout",
    "existing_cust",
    "invest_strat",
    "page_title",
    "modalpremium",
    "traiflag",
    "staff",
    "selectedfunds",
    "appformdetails",
    "communication",
    "health",
    "productselection",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "kycwaveoff",
    "stay_details",
    "proposer_stay_details",
    "suitabilitymatrix",
    "emailaddress",
    "sourceurl",
    "pan_validation_status",
    "existingcustomer",
    "qdata_pasa",
    "ekycdetails",
    // "health_la",
    // "health_pa",
    "education",
    "iswhatsappopted",
    "savingspercentage",
    "rideroptionadded",
    "iswop",
    "propage",
    "propdob",
    "propgender",
    // "wop_selctedoption",
    // "rider1",
    // "rider2",
    // "rider3",
    "city",
    "isnri",
    "lms_nri",
    "p_gender",
    "p_dob",
    "p_age",
    "p_ender",
    "qdata",
    "deathbenefitoption",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "maritalstatus",
    "NFOopt",
  ],
  giftcity_calcdata: [
    "age",
    "dob",
    "gender",
    "countrycode",
    "internationalmobileno",
    "nriarrivingdate",
    "nrimoblieno",
    "state",
    "storycode",
    "wop_upto",
    "timestamp",
    "whole_life",
    "term",
    "sumassured",
    "mobileno",
    "emailid",
    "pincode",
    "premium",
    "occupation",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "uid",
    "annualincome",
    "step",
    "payout",
    "existing_cust",
    "invest_strat",
    "modalpremium",
    "staff",
    "traiflag",
    "p_gender",
    "p_dob",
    "p_age",
    "education",
    "iswhatsappopted",
    "isnri",
    "lms_nri",
    "iswop",
    "city",
    "p_ender",
    "suitcheckbox",
    "qdata",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "pri_medical_data",
    "isdefaultpastrequired",
    "lduid",
    "samultiple",
    "savingspercentage",
    "funds_selected",
    "portfolio_startegy",
    "variant_name",
  ],
  giftcity_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "customer_name",
    "term",
    "sumassured",
    "mobileno",
    "internationalmobileno",
    "emailid",
    "pincode",
    "premium",
    "occupation",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "uid",
    "appno",
    "annualincome",
    "step",
    "payout",
    "existing_cust",
    "invest_strat",
    "modalpremium",
    "traiflag",
    "staff",
    "education",
    "iswhatsappopted",
    "savingspercentage",
    "iswop",
    "city",
    "isnri",
    "lms_nri",
    "p_gender",
    "p_dob",
    "p_age",
    "p_ender",
    "qdata",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "countrycode",
    "isdefaultpastrequired",
    "nriarrivingdate",
    "nrimoblieno",
    "samultiple",
    "state",
    "suitcheckbox",
    "wop_upto",
    "funds_selected",
    "portfolio_strategy",
    "lduid",
    "pri_medical_data",
    "storycode",
    "timestamp",
    "whole_life",
    "variant_name",
  ],
  GWA_calcdata: [
    // "age",
    // "dob",
    "DOB",
    "Investment_amount",
    "Payment_mode",
    "Policy_term",
    "Payment_frequency",
    "Maturity_benefit_4ARR",
    "Maturity_benefit_8ARR",
    "Life_cover",
    "Fund1_name",
    "Fund2_name",
    "Fund3_name",
    "Fund4_name",
    "Fund1_3y",
    "Fund2_3y",
    "Fund3_3y",
    "Fund4_3y",
    "Fund1_5y",
    "Fund2_5y",
    "Fund3_5y",
    "Fund4_5y",
    "Fund1_10y",
    "Fund2_10y",
    "Fund3_10y",
    "Fund4_10y",
    // "gender",
    "Gender",
    "Waiver_premium",
    "Indian_mobile_number",
    "Intl_mobile_number",
    // "countrycode",
    // "internationalmobileno",
    // "nriarrivingdate",
    // "nrimoblieno",
    // "state",
    // "storycode",
    // "wop_upto",
    "Waiver_premium_upto",
    // "timestamp",
    // "whole_life",
    // "term",
    // "sumassured",
    // "mobileno",
    // "emailid",
    "Email_ID",
    // "pincode",
    // "premium",
    "occupation",
    // "trai",
    // "paymentoption",
    // "relation",
    // "mode",
    // "ppt",
    // "lifecover",
    // "productid",
    // "invest_type",
    // "outputobjhold_4",
    // "outputobjhold_8",
    // "uid",
    // "annualincome",
    "annual_income",
    "Country_residence",
    // "step",
    // "payout",
    // "existing_cust",
    // "invest_strat",
    // "modalpremium",
    // "staff",
    // "traiflag",
    // "p_gender",
    // "p_dob",
    // "p_age",
    // "education",
    // "iswhatsappopted",
    // "isnri",
    // "lms_nri",
    // "iswop",
    // "city",
    // "p_ender",
    // "suitcheckbox",
    // "qdata",
    // "brochure_selected",
    // "tollfree_selected",
    // "isandroid",
    // "isios",
    // "pri_medical_data",
    // "isdefaultpastrequired",
    // "lduid",
    // "samultiple",
    // "savingspercentage",
    // "funds_selected",
    // "portfolio_startegy",
    // "variant_name",
  ],
  GWA_calcdata_drop: [
    // "age",
    // "dob",
    "DOB",
    "Investment_amount",
    "Payment_mode",
    "Policy_term",
    "Payment_frequency",
    "Maturity_benefit_4ARR",
    "Maturity_benefit_8ARR",
    "Life_cover",
    "Fund1_name",
    "Fund2_name",
    "Fund3_name",
    "Fund4_name",
    "Fund1_3y",
    "Fund2_3y",
    "Fund3_3y",
    "Fund4_3y",
    "Fund1_5y",
    "Fund2_5y",
    "Fund3_5y",
    "Fund4_5y",
    "Fund1_10y",
    "Fund2_10y",
    "Fund3_10y",
    "Fund4_10y",
    // "gender",
    "Gender",
    "Waiver_premium",
    "Indian_mobile_number",
    "Intl_mobile_number",
    // "customer_name",
    // "term",
    // "sumassured",
    // "mobileno",
    // "internationalmobileno",
    // "emailid",
    "Email_ID",
    // "pincode",
    // "premium",
    "occupation",
    // "trai",
    // "paymentoption",
    // "relation",
    // "mode",
    // "ppt",
    // "lifecover",
    // "productid",
    // "invest_type",
    // "outputobjhold_4",
    // "outputobjhold_8",
    // "uid",
    // "appno",
    "App_no",
    // "annualincome",
    "annual_income",
    "Country_residence",
    // "step",
    // "payout",
    // "existing_cust",
    // "invest_strat",
    // "modalpremium",
    // "traiflag",
    // "staff",
    // "education",
    // "iswhatsappopted",
    // "savingspercentage",
    // "iswop",
    // "city",
    // "isnri",
    // "lms_nri",
    // "p_gender",
    // "p_dob",
    // "p_age",
    // "p_ender",
    // "qdata",
    // "brochure_selected",
    // "tollfree_selected",
    // "isandroid",
    // "isios",
    // "countrycode",
    // "isdefaultpastrequired",
    // "nriarrivingdate",
    // "nrimoblieno",
    // "samultiple",
    // "state",
    // "suitcheckbox",
    // "wop_upto",
    "Waiver_premium_upto",
    // "funds_selected",
    // "portfolio_strategy",
    // "lduid",
    // "pri_medical_data",
    // "storycode",
    // "timestamp",
    // "whole_life",
    // "variant_name",
  ],
  giftpro_calcdata: [
    "annualincome",
    "age",
    "dob",
    "gender",
    "occupation",
    "p_gender",
    "p_dob",
    "getincome",
    "mobileno",
    "emailid",
    "trai",
    "traiflag",
    "paymentoption",
    "samultiple",
    "whole_life",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifecover",
    "payout",
    "staff",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "calctype",
    "selectedfunds",
    "existing_cust",
    "_epoch",
    "_visid",
    "income_frequency",
    "policyterm",
    "income_date",
    "modalpremium",
    "specialdate",
    "defermentperiod",
    "incomemode",
    "payoutoption",
    "payoutterm",
    "deathbenefitoption",
    "guranteed_returns",
    "guaranteedcashbenefit",
    "guaranteedcashbenefit2",
    "total_amount",
    "channel",
    "emp_id",
    "employeeid",
    "early_income",
    "fname",
    "lname",
    "step",
    "desiredlifecover",
    "optforrop",
    "optformaturity",
    "mbpercentage",
    "mbbenefityear",
    "lcbflag",
    "annual_prem",
    "pensionfrequency",
    "whatsapp_flag",
    "rider1",
    "rider2",
    "rideroptionadded",
    "sumassured",
    "isnri",
    "lms_nri",
    "uid",
    "iswop",
    "wop_selctedoption",
    "rider3",
    "checktwo",
    "suitcheckbox",
    "p_age",
    "propdob",
    "propgender",
    "pincode",
    "city",
    "qdata",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "lduid",
    "lduid_source",
  ],
  giftpro_calcdata_drop: [
    "occupation",
    "payoutterm",
    "productid",
    "defermentperiod",
    "channel",
    "mobileno",
    "mbbenefityear",
    "annualincome",
    "relation",
    "mode",
    "lcbflag",
    "policyterm",
    "propgender",
    "early_income",
    "traiflag",
    "pincode",
    "fname",
    "appno",
    "whatsapp_flag",
    "guaranteedcashbenefit2",
    "total_amount",
    "dob",
    "samultiple",
    "income_date",
    "pensionfrequency",
    "existing_cust",
    "optforrop",
    "guranteed_returns",
    "pfp_pk_id",
    "gender",
    "city",
    "isnri",
    "lifecover",
    "employeeid",
    "payoutoption",
    "lname",
    "mbpercentage",
    "iswop",
    "premium",
    "lms_nri",
    "brochure_selected",
    "isios",
    "deathbenefitoption",
    "suitcheckbox",
    "specialdate",
    "guaranteedcashbenefit",
    "modalpremium",
    "income_frequency",
    "isandroid",
    "optformaturity",
    "p_age",
    "propdob",
    "emailid",
    "staff",
    "rideroptionadded",
    "pri_medical_data",
    "annual_prem",
    "ppt",
    "tollfree_selected",
    "step",
    "sumassured",
    "qdata",
    "incomemode",
    "age",
    "emp_id",
    "p_dob",
    "education",
    "getincome",
    "paymentoption",
    "invest_strat",
    "payout",
    "p_gender",
    "invest_type",
    "trai",
    "uid",
    "outputobjhold_8",
    "outputobjhold_4",
    "lduid",
    "term",
    "state",
    "lduid_source",
    "adbr",
    "whole_life",
  ],
  signature_assure_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "address",
    "pincode",
    "premium",
    "occupation",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "uid",
    "annualincome",
    "step",
    "adbr",
    "payout",
    "existing_cust",
    "invest_strat",
    "page_title",
    "modalpremium",
    "staff",
    "name",
    "selectoption_dropdown",
    "investvalue",
    "traiflag",
    "appformdetails",
    "communication",
    "health",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "sourceurl",
    "existingcustomer",
    "qdata_pasa",
    "stay_details",
    "proposer_stay_details",
    "p_gender",
    "p_dob",
    "p_age",
    "rideroptionadded",
    "education",
    "iswhatsappopted",
    "isnri",
    "lms_nri",
    "health_la",
    "health_pa",
    "iswop",
    "propage",
    "propdob",
    "propgender",
    "city",
    "p_ender",
    "suitcheckbox",
    "qdata",
    "deathbenefitoption",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "familyincome%",
    "maritalstatus",
    "fund_name",
  ],
  signature_assure_calcdata_drop: [
    "education",
    "occupation",
    "productid",
    "payout",
    "p_gender",
    "mobileno",
    "iswhatsappopted",
    "annualincome",
    "relation",
    "trai",
    "mode",
    "familyincomevalue",
    "storycode",
    "propgender",
    "traiflag",
    "adbr",
    "isdefaultpastrequired",
    "pincode",
    "paymentoption",
    "savingspercentage",
    "propage",
    "dob",
    "samultiple",
    "existing_cust",
    "p_dob",
    "pfp_pk_id",
    "gender",
    "city",
    "isnri",
    "invest_strat",
    "invest_type",
    "lifecover",
    "outputobjhold_8",
    "uid",
    "premium",
    "iswop",
    "outputobjhold_4",
    "familyincomeamt",
    "lms_nri",
    "term",
    "brochure_selected",
    "isios",
    "suitcheckbox",
    "isfamilyincome",
    "modalpremium",
    "isandroid",
    "propdob",
    "emailid",
    "staff",
    "rideroptionadded",
    "pri_medical_data",
    "ppt",
    "lduid",
    "tollfree_selected",
    "age",
    "whole_life",
    "critical_illness_benefit",
    "countrycode",
    "lifecovernew",
    "dobspouse",
    "nrimoblieno",
    "internationalmobileno",
    "adbterm",
    "accidental_death_benefit",
    "nriarrivingdate",
    "sumassured",
    "premiumwithci",
    "annual_income",
    "citerm",
    "timestamp",
    "qdata",
    "p_ender",
    "p_age",
    "step",
    "state",
    "sourceurl",
    "appno",
    "NFOopt",
  ],
  png_calcdata: [
    "education",
    "occupation",
    "productid",
    "desiredlifecover",
    "maxannualrange",
    "payout",
    "p_gender",
    "mobileno",
    "iswhatsappopted",
    "annualincome",
    "relation",
    "lifecovernew",
    "trai",
    "mode",
    "newannualincome",
    "traiflag",
    "adbr",
    "isdefaultpastrequired",
    "pincode",
    "continueappform",
    "paymentoption",
    "minannualrange",
    "savingspercentage",
    "la1_tobacco",
    "dob",
    "adby_selected",
    "samultiple",
    "existing_cust",
    "p_dob",
    "pfp_pk_id",
    "gender",
    "city",
    "invest_strat",
    "invest_type",
    "lifecover",
    "outputobjhold_8",
    "premium",
    "outputobjhold_4",
    "term",
    "brochure_selected",
    "isios",
    "suitcheckbox",
    "isandroid",
    "emailid",
    "staff",
    "adby_percentage",
    "pri_medical_data",
    "ppt",
    "lduid",
    "tollfree_selected",
    "qdata",
    "age",
    "whole_life",
    "critical_illness_benefit",
    "countrycode",
    "dobspouse",
    "uid",
    "nrimoblieno",
    "internationalmobileno",
    "adbterm",
    "accidental_death_benefit",
    "nriarrivingdate",
    "sumassured",
    "premiumwithci",
    "annual_income",
    "citerm",
    "timestamp",
    "step",
    "state",
  ],
  png_calcdata_drop: [
    "existing_cust",
    "appformdetails",
    "nominee",
    "communication",
    "health",
    "productselection",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "kycwaveoff",
    "suitabilitymatrix",
    "ekycdetails",
    "appno",
    "emailaddress",
    "uid",
    "sourceurl",
    "pan_validation_status",
    "existingcustomer",
    "qdata_pasa",
    "traiflag",
    "whatsapp_flag",
    "health_la",
    "health_pa",
    "ckycflag",
    "ekyc_flag",
    "annualincome",
    "newannualincome",
    "age",
    "dob",
    "gender",
    "p_gender",
    "p_dob",
    "mobileno",
    "emailid",
    "trai",
    "education",
    "occupation",
    "la1_tobacco",
    "pincode",
    "city",
    "paymentoption",
    "iswhatsappopted",
    "relation",
    "mode",
    "ppt",
    "term",
    "lifecovernew",
    "premium",
    "payout",
    "staff",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "funds",
    "swp",
    "fundcat",
    "selectedfunds",
    "savingspercentage",
    "step",
    "state",
    "suitcheckbox",
    "qdata",
    "continueappform",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "iswop",
    "propdob",
    "propgender",
    "NFOopt",
  ],
  gppflexi_calcdata: [
    "pincode",
    "critical_illness_benefit",
    "countrycode",
    "mobileno",
    "annualincome",
    "lifecovernew",
    "dobspouse",
    "uid",
    "nrimoblieno",
    "internationalmobileno",
    "premium",
    "ppt",
    "dob",
    "adbterm",
    "accidental_death_benefit",
    "nriarrivingdate",
    "term",
    "sumassured",
    "premiumwithci",
    "age",
    "annual_income",
    "citerm",
    "timestamp",
    "occupation",
    "productid",
    "investment_frequency",
    "channel",
    "p_gender",
    "session_uid",
    "plantype",
    "gauranteedbenefit",
    "mode",
    "policyterm",
    "monthly_premium",
    "purchasefor",
    "spouse_age",
    "funds",
    "keyword",
    "plan",
    "paymentfrequency",
    "adbr",
    "annuity_amount",
    "appno",
    "next_year_premium",
    "maritalstatus",
    "yearly_premium",
    "lead_type",
    "selectedplan",
    "existing_cust",
    "p_dob",
    "incomebenefit",
    "pfp_pk_id",
    "gender",
    "city",
    "isnri",
    "lifecover",
    "spouse_dob",
    "spouse_relation",
    "payoutoptions",
    "spouse_name",
    "matchtype",
    "nps_flag",
    "lms_nri",
    "brochure_selected",
    "suitcheckbox",
    "specialdate",
    "p_age",
    "emailid",
    "staff",
    "reverse",
    "pensionfor",
    "pri_medical_data",
    "spouse_gender",
    "trai_flag",
    "tollfree_selected",
    "premiumpaymentoption",
    "qdata",
    "income_date",
    "guranteed_returns",
    "outputobjhold_8",
    "outputobjhold_4",
    "education",
    "usetobacco",
    "step",
    "deferment_period",
    "rop_value",
    // "parent_age",
    // "parent_dob",
    // "pgender",
    // "health",
    // "payoutdetails",
    // "proposerdetails",
    // "sourceurl",
    // "qdata_pasa",
    // "stay_details",
    // "proposer_stay_details",
    // "transactionid",
    // "status",
    // "ekycdetails",
    // "health_la",
    // "health_pa",
    // "ckycflag",
    // "ekyc_flag",
    // "isandroid",
    // "isios",

    //    "paymentoption",
  ],
  gppflexi_calcdata_drop: [
    "pincode",
    "critical_illness_benefit",
    "countrycode",
    "mobileno",
    "annualincome",
    "lifecovernew",
    "dobspouse",
    "uid",
    "nrimoblieno",
    "internationalmobileno",
    "premium",
    "ppt",
    "dob",
    "adbterm",
    "accidental_death_benefit",
    "nriarrivingdate",
    "term",
    "sumassured",
    "premiumwithci",
    "age",
    "annual_income",
    "citerm",
    "timestamp",
    "occupation",
    "productid",
    "investment_frequency",
    "channel",
    "p_gender",
    "session_uid",
    "plantype",
    "gauranteedbenefit",
    "mode",
    "policyterm",
    "monthly_premium",
    "purchasefor",
    "spouse_age",
    "funds",
    "keyword",
    "plan",
    "paymentfrequency",
    "adbr",
    "annuity_amount",
    "appno",
    "next_year_premium",
    "maritalstatus",
    "yearly_premium",
    "lead_type",
    "selectedplan",
    "existing_cust",
    "p_dob",
    "guranteed_returns",
    "incomebenefit",
    "pfp_pk_id",
    "gender",
    "city",
    "isnri",
    "lifecover",
    "spouse_dob",
    "spouse_relation",
    "payoutoptions",
    "outputobjhold_8",
    "spouse_name",
    "outputobjhold_4",
    "matchtype",
    "nps_flag",
    "lms_nri",
    "brochure_selected",
    "suitcheckbox",
    "specialdate",
    "p_age",
    "emailid",
    "staff",
    "reverse",
    "pensionfor",
    "pri_medical_data",
    "spouse_gender",
    "trai_flag",
    "tollfree_selected",
    "premiumpaymentoption",
    "qdata",
    "step",
    "income_date",
    "education",
    "trai",
    "iswop",
    "paymentoption",
    "propdob",
    "propgender",
    "relation",
    "usetobacco",
    "deferment_period",
    "rop_value",
    // "parent_age",
    // "parent_dob",
    // "pgender",
    // "health",
    // "payoutdetails",
    // "proposerdetails",
    // "sourceurl",
    // "qdata_pasa",
    // "stay_details",
    // "proposer_stay_details",
    // "transactionid",
    // "status",
    // "ekycdetails",
    // "health_la",
    // "health_pa",
    // "ckycflag",
    // "ekyc_flag",
    // "isandroid",
    // "isios",
  ],
  saralpension_calcdata: [
    "existing_cust",
    "nps_flag",
    "isnri",
    "investment_amount",
    "gender",
    "maritalstatus",
    "dob",
    "age",
    "mobileno",
    "emailid",
    "city",
    "occupation",
    "annuity_frequency",
    "annuity_type",
    "spouse_dob",
    "spouse_gender",
    "spouse_name",
    "joint_life_name",
    "joint_life_dob",
    "joint_life_relationship",
    "annuity_option",
    "brochure_selected",
    "tollfree_selected",
    "qdata",
    "qdata_pasa",
    "sourceurl",
    "uid",
    "step",
    "trai",
    "productid",
    "staff",
  ],
  saralpension_calcdata_drop: [
    "education",
    "name_of_organisation",
    "organisation_type",
    "primary_pension_receiver_education",
    "primary_pension_receiver_name",
    "primary_pension_receiver_occupation",
    "secondary_pension_receiver_education",
    "secondary_pension_receiver_name",
    "secondary_pension_receiver_occupation",
    "secondary_pension_receiver_mobile_no",
    "pran_number",
    "pan_no",
    "nominee",
    "nominee_dob",
    "nominee_relationship",
    "nominee_gender",
    "identity_proof_used",
    "age_proof_used",
    "payoutdetails",
    "appno",
    "emailid",
    "submit_button_flag",
    "uid",
    "sourceurl",
    "qdata_pasa",
    "traiflag",
    "annualincome",
    "emailid",
    "maritalstatus",
    "qdata",
    "existing_cust",
    "nps_flag",
    "isnri",
    "investment_amount",
    "gender",
    "maritalstatus",
    "dob",
    "age",
    "mobileno",
    "emailid",
    "city",
    "occupation",
    "annuity_frequency",
    "annuity_type",
    "spouse_dob",
    "spouse_gender",
    "spouse_name",
    "joint_life_name",
    "joint_life_dob",
    "joint_life_relationship",
    "annuity_option",
    "brochure_selected",
    "tollfree_selected",
    "qdata",
    "qdata_pasa",
    "uid",
    "step",
    "trai",
    "productid",
    "staff",
  ],
  SIP_plus_calcdata: [
    "age",
    "DOB",
    "gender",
    "Payment_frequency",
    "mobileno",
    "emailid",
    "Premium",
    "occupation",
    "ppt",
    "Maturity_benefit_4",
    "Maturity_benefit_8",
    "fund_performance_1",
    "fund_performance_3",
    "fund_performance_5",
    "Fund_name",
    "SWP_opted",
    "SWP_type_opted",
    "Lifecover",
    "Quote_page_health_questionnaire",
    "qdata",
    "maritalstatus",
    "Maturity_benefit_FP1",
    "Maturity_benefit_FP3",
    "Maturity_benefit_FP5",
    "InvValue_5Y",
    "InvValue_10Y",
    "InvValue_15Y",
    "InvValue_20Y",
    "InvValue_25Y",
    "FV_5Y",
    "FV_10Y",
    "FV_15Y",
    "FV_20Y",
    "FV_25Y",
  ],
  SIP_plus_calcdata_drop: [
    "age",
    "DOB",
    "gender",
    "qdata",
    "Payment_frequency",
    "mobileno",
    "emailid",
    "Premium",
    "occupation",
    "PPT",
    "Maturity_benefit_4",
    "Maturity_benefit_8",
    "fund_performance_1",
    "fund_performance_3",
    "fund_performance_5",
    "Maturity_benefit_FP1",
    "Maturity_benefit_FP3",
    "Maturity_benefit_FP5",
    "Fund_name",
    "SWP_opted",
    "SWP_type_opted",
    "maritalstatus",
    "Lifecover",
    "appno",
    "Quote_page_health_questionnaire",
    "InvValue_5Y",
    "InvValue_10Y",
    "InvValue_15Y",
    "InvValue_20Y",
    "InvValue_25Y",
    "FV_5Y",
    "FV_10Y",
    "FV_15Y",
    "FV_20Y",
    "FV_25Y",
    "NFOopt",
  ],
  iWish_calcdata: [
    "vitalcare_SA",
    "surgicalcare_SA",
    "maternitycare_SA",
    "Pregnancy",
    "Pregnancy_week",
    "Dependent",
    "Life Assured",
    "Proposer Gender",
    "Proposer MobileNo",
    "Proposer Emailid",
    "Proposer DOB",
    "Proposer Annual Income",
    "Proposer Occupation",
    "surgicalcare_term",
    "Maternitycare_term",
    "Relation with LA",
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "annual_income",
    "occupation",
    "education",
    "mrt_sts",
    "uid",
    "page_name",
    "whatsapp_optin",
    "trai_flag_sm",
    "productid",
    "city",
    "productname",
    "existing_cust",
    "state",
    "nri",
    "ind_flag_nri",
    "internationalmobileno",
    "travelinlast1year",
    "nrimoblieno",
    "nriemail",
    "timestamp",
    "livinginindia",
    "nriarrivingdate",
    "qdata",
    "appno",
    "diabetes",
  ],
  iWish_calcdata_drop: [
    "vitalcare_SA",
    "surgicalcare_SA",
    "maternitycare_SA",
    "Pregnancy",
    "Pregnancy_week",
    "Dependent",
    "Life Assured",
    "Proposer Gender",
    "Proposer MobileNo",
    "Proposer Emailid",
    "Proposer DOB",
    "Proposer Annual Income",
    "Proposer Occupation",
    "surgicalcare_term",
    "Maternitycare_term",
    "Relation with LA",
    "age",
    "dob",
    "gender",
    "usetobacco",
    "staff",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "annual_income",
    "occupation",
    "education",
    "mrt_sts",
    "uid",
    "page_name",
    "whatsapp_optin",
    "trai_flag_sm",
    "productid",
    "city",
    "productname",
    "existing_cust",
    "state",
    "nri",
    "ind_flag_nri",
    "internationalmobileno",
    "travelinlast1year",
    "nrimoblieno",
    "nriemail",
    "timestamp",
    "livinginindia",
    "nriarrivingdate",
    "qdata",
    "appno",
    "diabetes",
  ],
  smartkid_assure_calcdata: [
    "existing_cust",
    "name",
    "annualincome",
    "age",
    "dob",
    "gender",
    "mobileno",
    "emailid",
    "trai",
    "paymentoption",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifecover",
    "payout",
    "staff",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "funds",
    "swp",
    "fundcat",
    "selectedfunds",
    "step",
    "cdob",
    "cage",
    "payfor",
    "paymentfreq",
    "isnri",
    "crelation",
    "appointeegender",
    "appointeerelation",
    "cgender",
    "rideroptionadded",
    "rider1",
    "rider2",
    "occupation",
    "pagename",
    "savingspercentage",
    "onlinebenefit",
    "pincode",
    "city",
    "suitcheckbox",
    "qdata",
    "trai_flag",
    "existingcustomer",
    "uid",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "storycode",
    "wop_selctedoption",
    "plan type",
    "rider3",
    "iswop",
    "p_gender",
    "p_dob",
    "p_age",
    "Child_name",
    "Premium_Waiver",
    "Maturity_Amount",
  ],
  smartkid_assure_calcdata_drop: [
    // These keys are commented out because they are not present in the live Netcore object.
    // "cdob",
    // "cage",
    // "crelation",
    // "cgender",
    // "appointeegender",
    // "appointeerelation",
    // "funds",
    // "swp",
    // "payfor",
    // "paymentfreq",
    // "onlinebenefit",
    // "plan type",
    // "rider3",
    // "NFOopt",
    "name",
    "annualincome",
    "age",
    "dob",
    "gender",
    "mobileno",
    "emailid",
    "trai",
    "paymentoption",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifecover",
    "payout",
    "staff",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "fundcat",
    "selectedfunds",
    "occupation",
    "existing_cust",
    "step",
    "pagename",
    "savingspercentage",
    "pincode",
    "city",
    "appno",
    "suitcheckbox",
    "qdata",
    "brochure_selected",
    "tollfree_selected",
    "iswop",
    "propdob",
    "propgender",
    "isandroid",
    "isios",
    "p_gender",
    "p_dob",
    "p_age",
    "wop_selctedoption",
    "Child_name",
    "Premium_Waiver",
    "Maturity_Amount",
    "education",
    "emailaddress",
    "existingcustomer",
    "investvalue",
    "isnri",
    "iswhatsappopted",
    "lms_nri",
    "maritalstatus",
    "modalpremium",
    "nominee",
    "p_ender",
    "page_title",
    "paymentfrequency",
    "propage",
    "qdata_pasa",
    "rider1",
    "rideroptionadded",
    "sourceurl",
    "uid",
    "firstname",
    "lastname",
    "address",
    "selectoption_dropdown",
    "traiflag",
    "appformdetails",
    "communication",
    "health",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "stay_details",
    "proposer_stay_details",
    "health_la",
    "health_pa",
    "deathbenefitoption",
    "productselection",
    "kycwaveoff",
    "suitabilitymatrix",
    "pan_validation_status",
    "ekycdetails",
    "currentpagestep",
    "isenglish",
    "trai_flag",
  ],
  ipsSuper_calcdata: [
    "age",
    "dob",
    "gender",
    "Premium_break",
    "adjusted_premiun",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "atpdterm",
    "adbterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "occupation",
    "education",
    "mrt_sts",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "city",
    "existing_cust",
    "diabetes",
    "countrycode",
    "countryname",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age 1",
    "smart_exit_age 2",
    "smart_exit_age 3",
    "atpd_cover_gst",
    "adb_cover_gst",
    "atpd_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "premium_without_gst",
    "total_gst",
    "lifecover",
    "smart_exit_upperage",
    "smart_exit_entryage",
    "smart_exit_eligible_age",
    "cover_till_age",
    "accidental_disability_benefit",
  ],
  ipsSuper_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "Premium_break",
    "adjusted_premiun",
    "usetobacco",
    "staff",
    "channel",
    "term",
    "atpdterm",
    "adbterm",
    "premiumpaymentoption",
    "accidental_death_benefit",
    "accidental_disability_benefit",
    "payoutoptions",
    "paymentfrequency",
    "plan",
    "mobileno",
    "emailid",
    "trai_flag",
    "pincode",
    "ppt",
    "premium",
    "nominee",
    "occupation",
    "education",
    "mrt_sts",
    "appno",
    "uid",
    "sumassured2",
    "annualincome",
    "page_name",
    "persona",
    "whatsapp_optin",
    "martialstatus",
    "city",
    "existing_cust",
    "diabetes",
    "isenglish",
    "dobspouse",
    "spouseeducation",
    "spouseoccupation",
    "spousetobacco",
    "qdata",
    "spousedetails",
    "currentpagestep",
    "ppt_savings_with_gst",
    "ppt_savings_percent_with_gst",
    "ppt_savings",
    "ppt_savings_percent",
    "female_discount_percent",
    "salaried_percent",
    "online_discount",
    "female_discount_percent_gst",
    "salaried_percent_gst",
    "online_discount_gst",
    "female_discount_percent_without_gst",
    "salaried_percent_without_gst",
    "online_discount_without_gst",
    "smart_exit_eligible",
    "smart_exit_age 1",
    "smart_exit_age 2",
    "smart_exit_age 3",
    "atpd_cover_gst",
    "adb_cover_gst",
    "atpd_cover_without_gst",
    "adb_cover_without_gst",
    "db_payout_savings_amount_gst",
    "db_payout_savings_percent_gst",
    "db_payout_savings_amount",
    "db_payout_savings_percent",
    "premium_3years_gst",
    "premium_5years_gst",
    "premium_3years",
    "premium_5years",
    "premium_without_gst",
    "total_gst",
    "lifecover",
    "smart_exit_upperage",
    "smart_exit_entryage",
    "smart_exit_eligible_age",
    "cover_till_age",
    "accidental_disability_benefit",
  ],
  Quote_Agent_SigAssure: [
    "age",
    "dob",
    "gender",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "premium",
    "paymentoption",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "uid",
    "annualincome",
    "adbr",
    "payout",
    "existing_cust",
    "invest_strat",
    "page_title",
    "modalpremium",
    "existingcustomer",
    "rideroptionadded",
    "education",
    "iswhatsappopted",
    "isnri",
    "lms_nri",
    "health_la",
    "health_pa",
    "propage",
    "propdob",
    "propgender",
    "city",
    "p_ender",
    "qdata",
    "deathbenefitoption",
    "isandroid",
    "isios",
    "fund_performance_1",
    "fund_performance_3",
    "fund_performance_5",
    "fund_performance_10",
    "fund_performance_rsi",
    "maturity_benefit_1fp",
    "maturity_benefit_3fp",
    "maturity_benefit_5fp",
    "maturity_benefit_10fp",
    "maturity_benefit_rsifp",
    "swp_opted",
    "swp_type_opted",
    "agentid",
    "lmsid",
    "fund_name",
  ],
  Quote_Agent_SKA: [
    "name",
    "annualincome",
    "age",
    "dob",
    "gender",
    "mobileno",
    "emailid",
    "paymentoption",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifecover",
    "payout",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "selectedfunds",
    "cdob",
    "cage",
    "payfor",
    "paymentfreq",
    "isnri",
    "crelation",
    "appointeegender",
    "appointeerelation",
    "cgender",
    "rideroptionadded",
    "rider1",
    "rider2",
    "occupation",
    "pagename",
    "savingspercentage",
    "onlinebenefit",
    "pincode",
    "city",
    "qdata",
    "trai_flag",
    "existingcustomer",
    "uid",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "storycode",
    "wop_selctedoption",
    "plan type",
    "rider3",
    "iswop",
    "fund_performance_1",
    "fund_performance_3",
    "fund_performance_5",
    "fund_performance_10",
    "fund_performance_rsi",
    "maturity_benefit_1fp",
    "maturity_benefit_3fp",
    "maturity_benefit_5fp",
    "maturity_benefit_10fp",
    "maturity_benefit_rsifp",
    "swp_opted",
    "swp_type_opted",
    "agentid",
    "lmsid",
    "fund_name",
    "family_income",
    "premium_waiver_amount",
  ],
  cg2_calcdata: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "address",
    "pincode",
    "premium",
    "occupation",
    // "nominee",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "uid",
    "annualincome",
    "step",
    "adbr",
    "payout",
    "existing_cust",
    "invest_strat",
    // "fundcat",
    "page_title",
    "modalpremium",
    "staff",
    "name",
    "selectoption_dropdown",
    "investvalue",
    "traiflag",
    "appformdetails",
    "communication",
    "health",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "sourceurl",
    "existingcustomer",
    "qdata_pasa",
    "stay_details",
    "proposer_stay_details",
    "p_gender",
    "p_dob",
    "p_age",
    "rideroptionadded",
    // "rider1",
    // "rider2",
    "education",
    "iswhatsappopted",
    "isnri",
    "lms_nri",
    "health_la",
    "health_pa",
    "iswop",
    // "wop_selctedoption",
    // "rider3",
    "propage",
    "propdob",
    "propgender",
    "city",
    "p_ender",
    "suitcheckbox",
    "qdata",
    "deathbenefitoption",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "maritalstatus",
  ],
  cg2_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "usetobacco",
    "term",
    "premiumpaymentoption",
    "sumassured",
    "payoutoptions",
    "paymentfrequency",
    "firstname",
    "lastname",
    "mobileno",
    "emailid",
    "address",
    "pincode",
    "premium",
    "occupation",
    // "nominee",
    "trai",
    "paymentoption",
    "relation",
    "mode",
    "ppt",
    "lifecover",
    "productid",
    "invest_type",
    "outputobjhold_4",
    "outputobjhold_8",
    "pagename",
    "uid",
    "appno",
    "annualincome",
    "step",
    "adbr",
    "payout",
    "existing_cust",
    "invest_strat",
    "page_title",
    "modalpremium",
    "traiflag",
    "staff",
    "selectedfunds",
    "appformdetails",
    "communication",
    "health",
    "productselection",
    "payoutdetails",
    "proposerdetails",
    "proposercommunication",
    "kycwaveoff",
    "stay_details",
    "proposer_stay_details",
    "suitabilitymatrix",
    "emailaddress",
    "sourceurl",
    "pan_validation_status",
    "existingcustomer",
    "qdata_pasa",
    "ekycdetails",
    // "health_la",
    // "health_pa",
    "education",
    "iswhatsappopted",
    "savingspercentage",
    "rideroptionadded",
    "iswop",
    "propage",
    "propdob",
    "propgender",
    // "wop_selctedoption",
    // "rider1",
    // "rider2",
    // "rider3",
    "city",
    "isnri",
    "lms_nri",
    "p_gender",
    "p_dob",
    "p_age",
    "p_ender",
    "qdata",
    "deathbenefitoption",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "maritalstatus",
  ],

  USP_calcdata: [
    "age",
    "dob",
    "gender",
    "emailid",
    "mobileno",
    "annual_income",
    "city",
    "countrycode",
    "education",
    "occupation",
    "pincode",
    "productid",
    "fund_name",
    "fund_performance_5year",
    "fund_performance_10_year",
    "fund_performance_sinceinception",
    "fv_10y",
    "fv_15y",
    "fv_20y",
    "fv_25y",
    "fv_5y",
    "invvalue_5y",
    "invvalue_10y",
    "invvalue_15y",
    "invvalue_20y",
    "invvalue_25y",
    "lifecover",
    "maturity_benefit_4",
    "maturity_benefit_8",
    "maturity_benefit_fp5years",
    "maturity_benefit_fp10years",
    "maturity_benefit_fpSinceinception",
    "payment_frequency",
    "ppt",
    "premium",
    "annual_prem",
    "totalpremium",
    "sumassured",
    "samultiple",
    "you_are_viewing",
    "plan_selected",
    "do_you_want_wop",
    "qdata",
    "swp_opted",
    "swp_type_opted",
    "swp_reg_payout_income_frequency",
    "swp_reg_payout_payout_start_age",
    "swp_reg_payout_payout",
    "swp_reg_payout_payout",
    "swp_reg_payout_special_date",
    "swp_diy_income_frequency",
    "swp_diy_payout_1_year",
    "swp_div_payout_1",
    "swp_diy_payout_2_year",
    "swp_diy_payout_2",
    "swp_diy_payout_3_year",
    "swp_diy_payout_3",
    "swp_diy_payout_4_year",
    "swp_diy_payout_4",
    "swp_diy_payout_5_year",
    "swp_diy_payout_5",
    "swp_diy_special_date",
    "premium_waiver_Upto",
    "familyincomeopted",
    "familyincome",
    "familyincomevalue",
    "invest_strat",
    "iswhatsappopted",
    "uid",
    "defermentperiod",
    "early_income",
    "income_startdate",
    "income_term_gift",
    "incomeamount_gift",
    "moneybackoption_gift",
    "income_frequency",
    "incomemode",
    "mbbenefityear",
    "mbpercentage",
    "moneyback_amount",
    "wop_rider_opted",
    "wop_rider_premium",
    "adb_rider_opted",
    "adb_rider_sum_assured",
    "adb_rider_premium",
    "adb_term",
    "atpd_rider_opted",
    "atpd_rider_sum_assured",
    "atpd_rider_premium",
    "selectedfunds",
    "optforlowcoverincomebooster_gift",
    "save_the_date_gift",
    "total_amount_gift",
    "tax_savings_amount",
    // "NFOopt",
    "trai_flag",
    "isEnglish",
  ],
  USP_calcdata_drop: [
    "age",
    "dob",
    "gender",
    "emailid",
    "mobileno",
    "annual_income",
    "city",
    "state",
    "countrycode",
    "education",
    "occupation",
    "pincode",
    "productid",
    "fund_name",
    "fund_performance_5year",
    "fund_performance_10_year",
    "fund_performance_sinceinception",
    "fv_10y",
    "fv_15y",
    "fv_20y",
    "fv_25y",
    "fv_5y",
    "invvalue_5y",
    "invvalue_10y",
    "invvalue_15y",
    "invvalue_20y",
    "invvalue_25y",
    "lifecover",
    "maritalstatus",
    "maturity_benefit_4",
    "maturity_benefit_8",
    "maturity_benefit_fp5years",
    "maturity_benefit_fp10years",
    "maturity_benefit_fpSinceinception",
    "payment_frequency",
    "ppt",
    "premium",
    "annual_prem",
    "totalpremium",
    "sumassured",
    "samultiple",
    "you_are_viewing",
    "plan_selected",
    "do_you_want_wop",
    "qdata",
    "swp_opted",
    "swp_type_opted",
    "swp_reg_payout_income_frequency",
    "swp_reg_payout_payout_start_age",
    "swp_reg_payout_payout",
    "swp_reg_payout_payout",
    "swp_reg_payout_special_date",
    "swp_diy_income_frequency",
    "swp_diy_payout_1_year",
    "swp_div_payout_1",
    "swp_diy_payout_2_year",
    "swp_diy_payout_2",
    "swp_diy_payout_3_year",
    "swp_diy_payout_3",
    "swp_diy_payout_4_year",
    "swp_diy_payout_4",
    "swp_diy_payout_5_year",
    "swp_diy_payout_5",
    "swp_diy_special_date",
    "premium_waiver_Upto",
    "familyincomeopted",
    "familyincome",
    "familyincomevalue",
    "invest_strat",
    "iswhatsappopted",
    "uid",
    "defermentperiod",
    "early_income",
    "income_startdate",
    "income_term_gift",
    "incomeamount_gift",
    "moneybackoption_gift",
    "income_frequency",
    "incomemode",
    "mbbenefityear",
    "mbpercentage",
    "moneyback_amount",
    "wop_rider_opted",
    "wop_rider_premium",
    "adb_rider_opted",
    "adb_rider_sum_assured",
    "adb_rider_premium",
    "adb_term",
    "atpd_rider_opted",
    "atpd_rider_sum_assured",
    "atpd_rider_premium",
    "selectedfunds",
    "optforlowcoverincomebooster_gift",
    "save_the_date_gift",
    "total_amount_gift",
    "tax_savings_amount",
    // "NFOopt",
    "trai_flag",
    "isEnglish",
  ],
  signature_secure_calcdata: [
    "dob",
    "annual_income",
    "mobile",
    "email_id",
    "gender",
    "occupation",
    "pin",
    "city",
    "qualification",
    "premium",
    "lifecover",
    "arr_4",
    "arr_8",
    "guaranteed_benefit",
    "fund_name",
    "qdata",
    "tax_saved",
    "app_no",
    "trai_flag",
    "isenglish",
    "currentpagestep",
  ],
  signature_secure_calcdata_drop: [
    "dob",
    "annual_income",
    "mobile",
    "email_id",
    "gender",
    "occupation",
    "pin",
    "city",
    "qualification",
    "premium",
    "lifecover",
    "arr_4",
    "arr_8",
    "guaranteed_benefit",
    "fund_name",
    "qdata",
    "tax_saved",
    "customer_name",
    "app_no",
    "marital_status",
    "trai_flag",
    "isenglish",
    "currentpagestep",
  ],
  signature_pension_calcdata: [
    "AnnualIncome",
    "age",
    "dob",
    "gender",
    "Maritalstatus",
    "MobileNo",
    "EmailId",
    "isNRI",
    "State",
    "lms_nri",
    "Education",
    "Occupation",
    "p_gender",
    "p_dob",
    "trai",
    "suitCheckbox",
    "traiFlag",
    "isWhatsappOpted",
    "paymentOption",
    "saMultiple",
    "whole_life",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifeCover",
    "payout",
    "staff",
    "adbr",
    "productId",
    "invest_type",
    "invest_strat",
    "OutputObjHold_4",
    "OutputObjHold_8",
    "SavingsPercentage",
    "Pincode",
    "City",
    "isDefaultPastRequired",
    "RiderOptionAdded",
    "IsWOP",
    "propAge",
    "propDob",
    "propGender",
    "LDUID",
    "brochure_selected",
    "Tollfree_selected",
    "youth_express",
    "qdata",
    "lifeStage",
    "riskProfile",
    "FFGoal",
    "goalHorizon",
    "Existing_Cust",
    "uid",
    "PFP_PK_ID",
    "PRI_MEDICAL_DATA",
    "trai_flag",
    "projected_rate",
    "date_rateproject",
    "fund_name",
    "corpus_value",
  ],
  signature_pension_calcdata_drop: [
    "appNO",
    "AnnualIncome",
    "age",
    "dob",
    "gender",
    "Maritalstatus",
    "MobileNo",
    "EmailId",
    "isNRI",
    "State",
    "lms_nri",
    "Education",
    "Occupation",
    "p_gender",
    "p_dob",
    "trai",
    "suitCheckbox",
    "traiFlag",
    "isWhatsappOpted",
    "paymentOption",
    "saMultiple",
    "whole_life",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifeCover",
    "payout",
    "staff",
    "adbr",
    "productId",
    "invest_type",
    "invest_strat",
    "OutputObjHold_4",
    "OutputObjHold_8",
    "SavingsPercentage",
    "Pincode",
    "City",
    "isDefaultPastRequired",
    "RiderOptionAdded",
    "IsWOP",
    "propAge",
    "propDob",
    "propGender",
    "LDUID",
    "brochure_selected",
    "Tollfree_selected",
    "youth_express",
    "qdata",
    "lifeStage",
    "riskProfile",
    "FFGoal",
    "goalHorizon",
    "Existing_Cust",
    "uid",
    "PFP_PK_ID",
    "PRI_MEDICAL_DATA",
    "projected_rate",
    "date_rateproject",
    "fund_name",
    "corpus_value",
  ],
  smartkid_360_calcdata: [
    "existing_cust",
    "name",
    "annualincome",
    "age",
    "dob",
    "gender",
    "mobileno",
    "emailid",
    "trai",
    "paymentoption",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifecover",
    "payout",
    "staff",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "funds",
    "swp",
    "fundcat",
    "selectedfunds",
    "step",
    "cdob",
    "cage",
    "payfor",
    "paymentfreq",
    "isnri",
    "crelation",
    "appointeegender",
    "appointeerelation",
    "cgender",
    "rideroptionadded",
    "rider1",
    "rider2",
    "occupation",
    "pagename",
    "savingspercentage",
    "onlinebenefit",
    "pincode",
    "city",
    "suitcheckbox",
    "qdata",
    "trai_flag",
    "existingcustomer",
    "uid",
    "brochure_selected",
    "tollfree_selected",
    "isandroid",
    "isios",
    "storycode",
    "wop_selctedoption",
    "plan type",
    "rider3",
    "iswop",
    "p_gender",
    "p_dob",
    "p_age",
    "Child_name",
    "Premium_Waiver",
    "Maturity_Amount",
  ],
  smartkid_360_calcdata_drop: [
    "cdob",
    "cage",
    "name",
    "annualincome",
    "age",
    "dob",
    "gender",
    "crelation",
    "cgender",
    "appointeegender",
    "appointeerelation",
    "mobileno",
    "emailid",
    "trai",
    "paymentoption",
    "relation",
    "premium",
    "mode",
    "ppt",
    "term",
    "lifecover",
    "payout",
    "staff",
    "adbr",
    "productid",
    "invest_type",
    "invest_strat",
    "outputobjhold_4",
    "outputobjhold_8",
    "funds",
    "swp",
    "fundcat",
    "selectedfunds",
    "occupation",
    "payfor",
    "paymentfreq",
    "existing_cust",
    "step",
    "pagename",
    "savingspercentage",
    "onlinebenefit",
    "pincode",
    "city",
    "appno",
    "suitcheckbox",
    "qdata",
    "brochure_selected",
    "tollfree_selected",
    "iswop",
    "propdob",
    "propgender",
    "isandroid",
    "isios",
    "p_gender",
    "p_dob",
    "p_age",
    "wop_selctedoption",
    "plan type",
    "rider3",
    "Child_name",
    "Premium_Waiver",
    "Maturity_Amount",
  ],
};
